var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "emd-card-grid__row" },
    [
      _c("TId", {
        attrs: {
          title: _vm.$t("charge.detail.payment-method.safetypay.tid"),
          "t-id": _vm.lastTransaction.acquirer_tid,
        },
      }),
      _c("DetailAt", {
        attrs: { "updated-at": _vm.updatedAt, "created-at": _vm.createdAt },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }